var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect, useState } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { EngageMessageType } from "engage-common/messages";
import { useNavigate } from "react-router-dom";
import Background, { BackgroundType } from "../components/Background";
import Welcome from "../components/Welcome";
import DisplayText, { TextVariant } from "../components/DisplayText";
import { EngageContext, ErrorType } from "../context";
import { ConfigContext } from "../index";
import TextField from "../components/TextField";
import Button from "../components/Button";
var useStyles = createUseStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        root: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        },
        actionButton: {
            display: "block",
            margin: [32, "auto"],
            padding: [16, 16],
            width: (_a = theme.welcome.actionButton.width) !== null && _a !== void 0 ? _a : "100%",
            color: theme.welcome.actionButton.color,
            border: theme.welcome.actionButton.border,
            borderRadius: 30,
            fontWeight: (_b = theme.welcome.actionButton.fontWeight) !== null && _b !== void 0 ? _b : 400,
        },
        container: {
            margin: { top: 16 },
            display: "flex",
            flexDirection: "column",
            padding: 8
        },
        loginForm: {
            margin: { top: 96 },
            flex: 1
        },
        input: {
            color: (_d = (_c = theme.welcome.textField) === null || _c === void 0 ? void 0 : _c.textColor) !== null && _d !== void 0 ? _d : "white",
            width: (_f = (_e = theme.welcome.textField) === null || _e === void 0 ? void 0 : _e.width) !== null && _f !== void 0 ? _f : "100%",
        }
    });
});
var HomePage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var navigate = useNavigate();
    var classes = useStyles();
    var _r = useContext(EngageContext), sendMessage = _r.sendMessage, user = _r.user, lobby = _r.lobby, errorMap = _r.errorMap, clearError = _r.clearError, lobbyValidation = _r.lobbyValidation;
    var _s = useContext(ConfigContext), title = _s.title, subtitle = _s.subtitle;
    var handleInputChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setFormValues(__assign(__assign({}, formValues), (_a = {}, _a[name] = value, _a)));
        clearError(ErrorType.NoLobby);
    };
    var onConnect = function (e) {
        e.preventDefault();
        sendMessage({ type: EngageMessageType.CheckLobby, lobbyID: formValues.joinCode });
    };
    var _t = useState({
        joinCode: ""
    }), formValues = _t[0], setFormValues = _t[1];
    var joinError = errorMap ? errorMap[ErrorType.NoLobby] : undefined;
    useEffect(function () {
        if ((user === null || user === void 0 ? void 0 : user.nickname) && lobby) {
            //If nickname is set on the lobby context, assume the connection is good and we're logged in.
            navigate("/app");
        }
        else if (lobbyValidation) {
            navigate("/j/".concat(lobbyValidation.lobbyID));
        }
    }, [user, lobby, lobbyValidation]);
    var theme = useTheme();
    return (React.createElement(Background, { type: BackgroundType.Welcome, showLicense: true, showSponsor: true },
        React.createElement("div", { className: classes.root },
            React.createElement(Welcome, { title: title }, subtitle),
            React.createElement("div", { className: classes.container },
                React.createElement("form", { onSubmit: onConnect, className: classes.loginForm },
                    React.createElement(TextField, { name: "joinCode", value: formValues.joinCode, required: true, onChange: handleInputChange, autoComplete: "off", className: classes.input, labelText: "Lobby Code", variant: "filled", backgroundColor: (_b = (_a = theme.welcome.textField) === null || _a === void 0 ? void 0 : _a.bgColor) !== null && _b !== void 0 ? _b : "#1D1F4266", backgroundHoverColor: (_d = (_c = theme.welcome.textField) === null || _c === void 0 ? void 0 : _c.bgHoverColor) !== null && _d !== void 0 ? _d : "#1D1F4299", foregroundColor: (_f = (_e = theme.welcome.textField) === null || _e === void 0 ? void 0 : _e.labelColor) !== null && _f !== void 0 ? _f : "lightgray", foregroundHoverColor: (_h = (_g = theme.welcome.textField) === null || _g === void 0 ? void 0 : _g.textColor) !== null && _h !== void 0 ? _h : "white", foregroundFocusColor: (_k = (_j = theme.welcome.textField) === null || _j === void 0 ? void 0 : _j.textColor) !== null && _k !== void 0 ? _k : "lightgray", textColor: (_m = (_l = theme.welcome.textField) === null || _l === void 0 ? void 0 : _l.textColor) !== null && _m !== void 0 ? _m : "white", errorText: joinError, errorColor: (_o = theme.welcome.textField) === null || _o === void 0 ? void 0 : _o.errorColor }),
                    React.createElement(Button, { className: classes.actionButton, type: "submit", backgroundColor: (_p = theme.welcome.actionButton.bgColor) !== null && _p !== void 0 ? _p : "secondary", lighten: theme.welcome.actionButton.lighten },
                        React.createElement(DisplayText, { variant: TextVariant.smallButton, color: (_q = theme.welcome.actionButton.color) !== null && _q !== void 0 ? _q : "white" }, "Join")))))));
};
export default HomePage;
//# sourceMappingURL=home.js.map